type ConvexApiRuntime = {
  api: unknown;
  internal: unknown;
};

// Runtime import keeps backend type generation out of this frontend package.
// Bun still resolves the generated module at bundle/runtime.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const convexApiRuntime = require("../../../../packages/backend/convex/_generated/api.js") as ConvexApiRuntime;

export const api = convexApiRuntime.api as any;
export const internal = convexApiRuntime.internal as any;
